import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import Detail from './components/Detail'
import List from './components/List'
import New from './components/New'
import CommissionPolicies from './components/CommissionPolicies'
import EmployeeList from './components/EmployeeList'

const AffiliateModule: RouteObject = {
    path: 'affiliates',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'new',
            element: <New />,
        },
        {
            path: 'commission-policies',
            element: <CommissionPolicies />,
        },
        {
            path: 'employees',
            element: <EmployeeList />,
        },
        {
            path: ':id',
            element: <Detail />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default AffiliateModule
